import {
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  ElementRef,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[appEmailBlacklistValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailBlacklistValidatorDirective,
      multi: true,
    },
  ],
})
export class EmailBlacklistValidatorDirective implements Validator, OnChanges {
  @Input('appEmailBlacklistValidator') blacklistedEmails: string[] = [];
  @Input('appEmailBlacklistValidatorShouldValidate') shouldValidate: boolean =
    true;

  private validator: ValidatorFn;
  private onChange: () => void = () => {};

  constructor(private el: ElementRef) {
    this.validator = EmailBlacklistValidatorDirective.emailBlacklistValidator(
      this.blacklistedEmails
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['blacklistedEmails'] || changes['shouldValidate']) {
      this.validator = EmailBlacklistValidatorDirective.emailBlacklistValidator(
        this.blacklistedEmails
      );
      this.onChange();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.shouldValidate) {
      return this.validator(control);
    } else {
      return null;
    }
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }

  static emailBlacklistValidator(blacklistedEmails: string[]): ValidatorFn {
    const blacklistSet = new Set(
      blacklistedEmails.map((email) => email.toLowerCase())
    );

    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const isBlacklisted = blacklistSet.has(control.value.toLowerCase());

      return isBlacklisted ? { emailBlacklisted: { valid: false } } : null;
    };
  }
}
